import {ReactNode} from 'react';
import {Typography} from '@/components/Typography';
import {PaddingBox} from '@/styled-components';
import {palette} from '@/styles';
import Image0101 from './img1-1.png';
import Image0102 from './img1-2.png';
import Image0103 from './img1-3.png';
import Image0201 from './img2-1.png';
import Image0202 from './img2-2.png';
import Image0203 from './img2-3.png';

export interface AccordionContentItem {
  title: string;
  desc: string | ReactNode;
  image: string;
}

export interface AccordionContent {
  title: string;
  desc?: string;
  items: AccordionContentItem[];
}

export const ACCORDION_CONTENTS: AccordionContent[] = [
  {
    title: '데이터를 한눈에!',
    desc: '누가 살고 있을까? 얼마나 벌고 있을까? 가장 궁금한 질문을 해결할 수 있어요',
    items: [
      {
        title: '배후 세대',
        desc: '주택 유형별로 얼마나 많은 세대가 거주하고 있는지 확인할 수 있어요.',
        image: Image0101,
      },
      {
        title: '매출',
        desc: (
          <div>
            분석 희망 지역에 위치한 가게들의 매출 데이터를 한눈에 보여드려요.
            <PaddingBox top={8}>
              <Typography
                variant="medium14"
                color={palette.gray400}
                lineHeight={1.5}
                letterSpacing="-0.42px"
                fontWeight={400}
              >
                *홀 매출 경우, 46개 업종에 대한 매출 데이터를 볼 수 있어요.
                <br />
                *배달 매출의 경우, 배달앱 3사의 총매출/총건수/객단가를 볼 수
                있어요.
              </Typography>
            </PaddingBox>
          </div>
        ),
        image: Image0102,
      },
      {
        title: '유동 인구',
        desc: '분석 희망 지역의 성별, 나이, 요일, 시간대별로 유동 인구를 확인 할 수 있어요.',
        image: Image0103,
      },
    ],
  },
  {
    title: '오직 마이프차 지도에서만!',
    items: [
      {
        title: '여러 지역의 상권 분석과 비교를 한 번에!',
        desc: '여기가 좋을까? 저기가 좋을까? 고민될 땐 상권 비교 기능을 통해 여러 상권의 데이터를 한 번에 비교할 수 있어요.',
        image: Image0201,
      },
      {
        title: '돈 잘 버는 스팟을 순위별로 한눈에!',
        desc: (
          <div>
            입지는 어디가 좋을까? 여기서 장사가 잘될까?
            <br />
            매출액* 상위 10% 스팟을 보면 어떤 업종이 어떤 입지에서 잘 되는지 알
            수 있어요.
            <PaddingBox top={8}>
              <Typography
                variant="medium14"
                color={palette.gray400}
                lineHeight={1.5}
                letterSpacing="-0.42px"
                fontWeight={400}
              >
                *매장당 평균 매출액
              </Typography>
            </PaddingBox>
          </div>
        ),
        image: Image0202,
      },
      {
        title: '주변 프랜차이즈 현황과 주변 정보 분석도 한 번에!',
        desc: (
          <div>
            이 상권은 왜 매출이 높을까? 주변 프랜차이즈 현황과 주변 정보를 통해
            매출에 직접적인 영향을 끼치는 또 다른 요인들을 알 수 있어요.
            <PaddingBox top={8}>
              <Typography
                variant="medium14"
                color={palette.teal100}
                lineHeight={1.5}
                letterSpacing="-0.42px"
                fontWeight={400}
              >
                *가맹점 최신 위치 정보를 가장 정확하게 반영해 제공하고 있어요.
                <br />
                *로드뷰 기능과 주변 정보 데이터를 통해 온라인 입지 분석이
                가능해요.
              </Typography>
            </PaddingBox>
          </div>
        ),
        image: Image0203,
      },
    ],
  },
];
